import { render, staticRenderFns } from "./UguReloads.vue?vue&type=template&id=5aa6c66a&"
import script from "./UguReloads.vue?vue&type=script&lang=js&"
export * from "./UguReloads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports